export function reportTarget(type, id, what = "isto") {
  window.dispatchEvent(new CustomEvent("enkosta:report", { detail: { type, id, what } }));
}
